import { Grid, Panel, Row } from '@indoqa/style-system';
import * as React from 'react';
import { FelaComponent } from 'react-fela';
import { withUIETheme } from '../uietheme/withUIETheme';
import { FontStylePanel } from './FontStylePanel';
import { characters } from './TextSpecimen';
const HeadlineSample = ({ fontStyles, fontSize, uieTheme, children }) => {
    const style = {
        marginBottom: uieTheme.spacing.space2,
        fontSize,
    };
    return React.createElement(FelaComponent, { style: [fontStyles, style] }, children);
};
const renderHeadlineSizeSamples = (fontStyles, fontSizes, uieTheme) => {
    return fontSizes.map((fontSize) => {
        return (React.createElement(HeadlineSample, { fontStyles: fontStyles, fontSize: fontSize, uieTheme: uieTheme, key: fontSize }, "The quick brown fox jumps over the lazy dog."));
    });
};
const HeadlineFontPanel = ({ fontStyles, fontSizes, name, uieTheme }) => {
    return (React.createElement(Grid, { fullWidth: true, spacing: "1rem" },
        React.createElement(Row, null,
            React.createElement(Panel, null,
                React.createElement(FontStylePanel, { name: `${name} / sizes` }, renderHeadlineSizeSamples(fontStyles, fontSizes, uieTheme))),
            React.createElement(Panel, null,
                React.createElement(FontStylePanel, { name: `${name} / characters` },
                    React.createElement(HeadlineSample, { fontStyles: fontStyles, fontSize: fontSizes[0], uieTheme: uieTheme }, characters))))));
};
export default withUIETheme(HeadlineFontPanel);
//# sourceMappingURL=HeadlineFontPanel.js.map